
import { BlogPost } from "@/types/blog";
import { sanitizeHtml } from "@/utils/htmlUtils";
import { transformBlogUrls } from "@/utils/urlTransformer";

interface ServerBlogListProps {
  posts: BlogPost[];
}

export const ServerBlogList = ({ posts }: ServerBlogListProps) => {
  if (!Array.isArray(posts) || posts.length === 0) {
    return <div>Nessun articolo disponibile</div>;
  }

  return (
    <>
      {/* Visible blog list for users */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map(post => (
          <div key={post.id} className="flex flex-col">
            <a 
              href={`/blog/${post.slug}`}
              className="group relative overflow-hidden rounded-lg"
            >
              {post.featuredImage && (
                <img 
                  src={transformBlogUrls(post.featuredImage)} 
                  alt={post.title} 
                  className="h-48 w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              )}
            </a>
            <div className="flex flex-col flex-grow mt-4">
              <h3 className="text-xl font-semibold mb-2 line-clamp-2">
                <a 
                  href={`/blog/${post.slug}`}
                  className="hover:text-primary transition-colors"
                >
                  {post.title}
                </a>
              </h3>
              <div 
                className="text-muted-foreground text-sm line-clamp-3 mb-3"
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(post.excerpt || '')
                }}
              />
              <div className="flex justify-between items-center mt-auto">
                <span className="text-xs text-muted-foreground">
                  {post.date ? new Date(post.date).toLocaleDateString('it-IT') : ''}
                </span>
                <a 
                  href={`/blog/${post.slug}`}
                  className="text-sm font-medium text-primary hover:underline"
                >
                  Leggi
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* SEO optimized content - only for crawlers */}
      <div className="server-blogs-seo" aria-hidden="true">
        {posts.map(post => (
          <article key={post.id} className="mb-8">
            <h2>{post.title}</h2>
            <div dangerouslySetInnerHTML={{
              __html: sanitizeHtml(post.excerpt || '')
            }} />
            <p>Data: {post.date ? new Date(post.date).toLocaleDateString('it-IT') : ''}</p>
            <p>Autore: {post.author?.name || 'Anonimo'}</p>
            <a href={`/blog/${post.slug}`}>Leggi l'articolo completo</a>
          </article>
        ))}
      </div>
    </>
  );
};
